/**
 * Created by zhangxiaoqing on 2018/04/17.
 */
// import * as types from '../mutation-types'
import * as types from '../mutation-types'
// import config from '@/assets/js/config.js'
// initial state
// shape: [{ id, quantity }]
const state = {
  menuData: window.sessionStorage.getItem('menuData') ? JSON.parse(window.sessionStorage.getItem('menuData')) : null,
  selectMenu: window.sessionStorage.getItem('selectMenu')? JSON.parse(window.sessionStorage.getItem('selectMenu')) : null,
  parentNavId: window.sessionStorage.getItem('parentNavId')? window.sessionStorage.getItem('parentNavId') : ''
}

// getters
const getters = {

}

// actions
const actions = {
  getMenuDataByPath(state, path){
    let menuData = {}
    state.state.menuData && state.state.menuData.map(item=>{
      let targetPath = item.url
      if(targetPath == path){
        return menuData = item
      }
    })
    return menuData
  }
}

// mutations
const mutations = {
  [types.UPDATEMENUDATA] (state, menuData) {
    state.menuData = [...menuData]
    menuData.length ? window.sessionStorage.setItem('menuData', JSON.stringify(menuData)) : window.sessionStorage.removeItem('menuData')
  },
  [types.SETSELECTMENU] (state, menuData) {
    // let menuData =  state.menuData.find(item => item.url && path.indexOf(item.url) == 0 ); // 当前路由是否是菜单
    // if(menuData && menuData.id != (state.selectMenu && state.selectMenu.id)){ // 路由是菜单 且 是和当前菜单不一样的菜单
      state.selectMenu = {...menuData}
      menuData && window.sessionStorage.setItem('selectMenu', JSON.stringify(menuData))
    // }
  },
  [types.PARENTNAVID] (state, parentNavId) {
    state.parentNavId = parentNavId
    parentNavId && window.sessionStorage.setItem('parentNavId', parentNavId)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/getApp.js